import Decode from './Decode';

export default Decode;
